var currentRequest = null;

const PropertyAutoComplete = {
    base_url: $('#base-url').attr('data-url'),
    handleResults(properties, $input) {
        var $results = $input.next('.property-autocomplete-results');
        $results.empty();

        $.each(properties, function (i, prop) {
            var $prop = `
                <li class="group property-autocomplete-results__item">
                    <a href="#" class="property-autocomplete-results__link">
                        <span class="text-brand-md-blue group-hover:text-brand-primary ">
                            ${prop.title}
                        </span>
                    </a>
                </li>
            `;
            $results.append($prop);
        });
        $results.addClass('is-active');

        // focus the first result
        $(document).on('keydown', PropertyAutoComplete.handleUpDown);

        $('.property-autocomplete-results__link').on('click', function () {
            var index = $(this).parent().index();
            PropertyAutoComplete.showContactInfo(properties[index], $input);
            PropertyAutoComplete.clearResults($input);
            $input.val('').blur();
            return false;
        });
    },
    showContactInfo(property, $input) {
        var $contact_html = '';
        if (property.property_manager_contacts) {
            $.each(property.property_manager_contacts, function (i, contact) {
                $contact_html += `
            <div>
                <div class="text-xl">${contact.position_title}</div>
                <div class="text-lg">${contact.name}</div>
                <div>
                    <strong>Phone:</strong>
                    <a href="tel:${contact.phone_number.replace(/\D/g, '')}">${
                    contact.phone_number
                }</a>
                </div>
                <div>
                    <strong>Email:</strong>
                    <a href="mailto:${contact.email_address}">${
                    contact.email_address
                }</a>
                </div>
            </div>`;
            });
        }
        var property_email_id = "";
        if (property.property_manager_contacts && property.property_manager_contacts[0] && property.property_manager_contacts[0].email_address) {
            property_email_id = property.property_manager_contacts[0].email_address;
        }
        var property_phone_number = "";
        if (property.property_manager_contacts && property.property_manager_contacts[0] && property.property_manager_contacts[0].phone_number) {
            property_phone_number = property.property_manager_contacts[0].phone_number;
        }
        var $html = `
            <div class="max-w-5xl mx-auto mb-8 prose text-center border-t mt-12 pt-12">
                <h2 class="">
                    ${ property.title}
                </h2>
            </div>
            <div class="max-w-5xl p-5 -mx-8 md:mx-auto text-center bg-center bg-cover">
                <div class="grid grid-cols-1 bg-white divide-y md:divide-x md:divide-y-0 md:grid-cols-2 overflow-hidden">
                    <div class="flex flex-col justify-center p-6 text-center">
                        <div class="mb-4 prose">
                            <h3>Resident Services</h3>
                            <p>For resident services such as maintenance and management assistance, please log into the resident portal.</p>
                        </div>
                        ${
                            property.resident_login_url
                                ? `<div><a href="${property.resident_login_url}" class=" button" target="_blank" rel="noopener noreferrer">Log In</a></div>`
                                : ``
                        }
                    </div>
                    <div class="flex flex-col justify-center p-6 prose text-center property-contact-info">
                        <h3>Contact</h3>
                        <div class="mb-8 property-contact-info__address">
                            <div class="property-contact-info__street">${
                                property.street_address
                            }</div>
                            <div class="property-contact-info__city">${
                                property.city
                            },
                                ${property.state}
                                ${property.zip_code}
                            </div>
                            <div class="property-contact-info__phone">
                                <a href="tel:${property_phone_number.replace(
                                    /\D/g,
                                    ''
                                )}">${property_phone_number}</a>
                            </div>
                            <div>                              
                                <a href="mailto:${property_email_id}">${
                                    property_email_id
                                }</a>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>  
            `;

        $('.chosen-property-contact-info').html($html);
        PropertyAutoComplete.clearResults($input);
    },
    clearResults($input) {
        var $results = $input.next('.property-autocomplete-results');
        $results.empty().removeClass('is-active');
    },
    doSearch($input) {
        $(document).off('keydown', PropertyAutoComplete.handleUpDown);

        if ($input.val().length < 1) {
            PropertyAutoComplete.clearResults($input);
        }

        currentRequest = $.ajax({
            url: PropertyAutoComplete.base_url + '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'contact_select_property_search',
                s: $input.val(),
            },
            beforeSend: function () {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function (data) {
                if (data) {
                    var properties = JSON.parse(data);
                    if (properties && properties.length > 0) {
                        PropertyAutoComplete.handleResults(properties, $input);
                    } else {
                        PropertyAutoComplete.clearResults($input);
                    }
                }
            },
        });
    },
    handleUpDown(e) {
        var $focused_li = $('.property-autocomplete-results a:focus').parent();

        // if in input, make the down press select the first option
        switch (e.keyCode) {
            case 38: // up
                if ($focused_li.length > 0 && $focused_li.index() > 0) {
                    // if in a result, select the previous result
                    $focused_li.prev().find('a').focus();
                    return false;
                }
                break;
            case 40: // down
                if ($('.property-autocomplete-input:focus').length > 0) {
                    $('.property-autocomplete-input:focus')
                        .next('.property-autocomplete-results')
                        .find('li')
                        .eq(0)
                        .find('a')
                        .trigger('focus');
                    return false;
                }

                if ($focused_li.length > 0 && $focused_li.next().length > 0) {
                    // if in a result, select the next result
                    $focused_li.next().find('a').focus();
                    $focused_li.next()[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });

                    return false;
                }
                break;
        }
    },
    init() {
        $('.property-autocomplete-input').each(function () {
            var $ac = $(this);
            $(this).on('keyup', function () {
                PropertyAutoComplete.doSearch($ac);
            });
        });

        $('.property-autocomplete-input').on('click', function () {
            PropertyAutoComplete.doSearch($(this));
        });

        // remove results on click outside
        $(document).on('click', function (event) {
            var $target = $(event.target);
            if (
                !$target.closest('.property-autocomplete').length &&
                $('.property-autocomplete').is(':visible')
            ) {
                PropertyAutoComplete.clearResults(
                    $('.property-autocomplete-input')
                );
            }
        });
    },
};

export default PropertyAutoComplete;
